import React, { Component } from 'react'
import InvoiceEmailHistory from './invoiceEmailHistory'
import Container from '../common/application_container'

export default class InvoiceEmailHistoryPage extends Component {
    render() {
        return (
            <Container title="Invoice" title1="Email History">
                <InvoiceEmailHistory />
            </Container>
        )
    }
}
